export enum FilterState {
  Valid = 'valid',
  DatasourceDeleted = 'datasource-deleted',
  ColumnDeleted = 'column-deleted',
  ColumnTypeDiff = 'column-type-diff',
}
